var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCheckmark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FD4319"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8042 7.02883C14.8663 7.09074 14.9155 7.16429 14.9491 7.24527C14.9827 7.32625 15 7.41306 15 7.50073C15 7.5884 14.9827 7.67521 14.9491 7.75619C14.9155 7.83717 14.8663 7.91072 14.8042 7.97263L8.8054 13.9714C8.74349 14.0335 8.66993 14.0827 8.58896 14.1163C8.50798 14.1499 8.42117 14.1672 8.3335 14.1672C8.24583 14.1672 8.15901 14.1499 8.07804 14.1163C7.99706 14.0827 7.92351 14.0335 7.86159 13.9714L5.19547 11.3053C5.07031 11.1801 5 11.0104 5 10.8334C5 10.6564 5.07031 10.4866 5.19547 10.3615C5.32063 10.2363 5.49037 10.166 5.66737 10.166C5.84437 10.166 6.01412 10.2363 6.13928 10.3615L8.3335 12.557L13.8604 7.02883C13.9223 6.96675 13.9958 6.91751 14.0768 6.88391C14.1578 6.8503 14.2446 6.83301 14.3323 6.83301C14.4199 6.83301 14.5068 6.8503 14.5877 6.88391C14.6687 6.91751 14.7423 6.96675 14.8042 7.02883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckmark2);
export default __webpack_public_path__ + "static/media/OrangeCheckmark2.d55e0a1ff14d51f74e6a2755008bb588.svg";
export { ForwardRef as ReactComponent };